
import CustomToolTip from '../../../../../../CommonComponents/CustomToolTip'
import { PlusSvg } from '../../../../../../CommonComponents/svgs/Svgs'

const NewAddButton = ({ onClick, title }: { onClick: () => void, title: string }) => {
    return (
        <div className='new__add__button__container'>
            <CustomToolTip title={title} placement='top'>
                <button className='new__add__button' onClick={(event) => {
                    event.stopPropagation()
                    onClick()
                }}>
                    <PlusSvg />
                </button>
            </CustomToolTip>
        </div>
    )
}

export default NewAddButton